import React from "react";
import "./Project.css";
import { projects } from "../../shared/constants";
import { Fade } from "react-awesome-reveal";
import ProjectCard from "../ProjectCard/ProjectCard";

function Projects(props: any) {
  return (
    <div className="main" id="educations">
      <div className="educations-header-div">
        <Fade duration={2000}>
          <h1
            className="educations-header"
            style={{
              color: props.theme.text,
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            Our Projects
          </h1>
        </Fade>
      </div>
      <div className="educations-body-div">
        {projects.map((degree: any) => {
          return <ProjectCard degree={degree} theme={props.theme} />;
        })}
      </div>
    </div>
  );
}

export default Projects;
